// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file telemetry/v1alpha/telemetry.proto (package com.seed.telemetry.v1alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { RecordCheckpointsRequest, RecordCheckpointsResponse } from "./telemetry_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Telemetry collects checkpoint timestamps from in-process emitters in the
 * daemon and from external processes (Electron main + renderers) so that we
 * can reconstruct the wall-clock journey of a single hypermedia URL through
 * the system.
 *
 * This is a debugging surface only — there is no auth and the server runs
 * behind the loopback-only HTTP debug routes. The wire schema is intentionally
 * tiny so the hot path stays free of allocations: emitters send
 * (key, stage, ts) tuples only. Generation assignment, stage classification,
 * abandonment detection and percentile rollups all happen on the server at
 * read time.
 *
 * @generated from service com.seed.telemetry.v1alpha.Telemetry
 */
export const Telemetry = {
  typeName: "com.seed.telemetry.v1alpha.Telemetry",
  methods: {
    /**
     * RecordCheckpoints appends a batch of checkpoints to the in-memory ring
     * buffer. Used by Electron main and renderers; in-process Go emitters call
     * the server's RecordCheckpoint helper directly.
     *
     * @generated from rpc com.seed.telemetry.v1alpha.Telemetry.RecordCheckpoints
     */
    recordCheckpoints: {
      name: "RecordCheckpoints",
      I: RecordCheckpointsRequest,
      O: RecordCheckpointsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

